<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<!-- <div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div> -->
		<a-form layout="inline" style="margin-bottom: 16px;">
			<a-form-item label="角色名称">
				<a-input v-model="filterData.nickname" placeholder="请输入角色名称" />
			</a-form-item>
			<a-form-item label="状态">
				<a-select style="width: 200px" v-model="filterData.commentManagerUserStatus" class="mr12"
					placeholder="状态" show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>
				<!-- <a-button class="mr12" @click="scriptEdit">话术编辑</a-button>
				<a-button class="mr12">导入</a-button> -->
				<a-button @click="toAdd" type="primary">新建角色</a-button>
			</a-form-item>
		</a-form>

		<!-- <div class="cate">
			<a-radio-group v-model="filterData.tagId" button-style="solid" @change="changeTab">
				<a-radio-button value="">全部</a-radio-button>
				<a-radio-button v-for="item in tags" :key="item.tagId" :value="item.tagId">
					{{ item.tagName }}
				</a-radio-button>
			</a-radio-group>
		</div> -->



		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="imageUrl" slot-scope="text, record">
				<viewer :images="[record.avatar]">
					<div class="er_content">
						<img class="er_content_img" :src="img" v-for="(img,index) in [record.avatar]" :key="index">
					</div>
				</viewer>
			</template>

			<template slot="sexRender" slot-scope="text, record">
				<div>
					<span v-if="record.sex==1">男</span>
					<span v-if="record.sex==2">女</span>
				</div>
			</template>

			<template slot="commentManagerUserStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.commentManagerUserStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.commentManagerUserStatus == true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.commentManagerUserStatus == false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>

			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>
			<!-- 编辑，删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span><a-button  type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗？" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link">删除</a-button>
					</a-popconfirm>
				</div>
			</template>

		</a-table>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="800px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<!-- :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" -->
			<a-form-model ref="formRef" :model="editModel" :rules="editRules">
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="角色头像" prop="avatar" required>
							<div style="display: flex;align-items: center;">
								<div v-if="editModel.avatar">
									<viewer :images="[editModel.avatar]">
										<div class="er_content">
											<img class="er_content_img" :src="img"
												v-for="(img,index) in [editModel.avatar]" :key="index">
										</div>
									</viewer>
								</div>

								<div class="again_upload_box ml12">
									<a-spin v-if="uploadLoading" size="small" style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;" />
									<input v-else type="file" accept="image/*" @change="handleUploadThumbnail" />
									<i v-if="!uploadLoading" class="el-icon-box again_upload_icon"></i>
									<div v-if="!uploadLoading" class="bold" style="width: 100px">
										{{ editModel.avatar ? "重新上传" : "选择上传文件" }}
									</div>
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="12">
						<a-form-model-item label="角色名称" prop="nickname" required>
							<a-input v-model="editModel.nickname" placeholder="请输入角色名称" :maxLength="20" />
						</a-form-model-item>
					</a-col>
				</a-row>


<!--				<a-row>-->
<!--					<a-col :span="24">-->
<!--						<a-form-model-item label="所在地" prop="areaCode">-->
<!--							<a-cascader  v-model="editModel.areaCode" :field-names="{ label: 'text', value: 'value', children: 'children' }" :options="cityList"-->
<!--					placeholder="所在地" @change="onChange" />-->
<!--						</a-form-model-item>-->
<!--					</a-col>-->
<!--				</a-row>-->

				<a-row>
					<a-col :span="12">
						<a-form-model-item label="性别" prop="sex" required>
							<a-select v-model="editModel.sex" placeholder="请选择性别">
								<a-select-option :value="1">男</a-select-option>
								<a-select-option :value="2">女</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="12">
						<a-form-model-item label="角色简介" prop="userDesc" required>
							<a-textarea v-model="editModel.userDesc" rows="4" placeholder="请输入角色简介" :maxLength="100" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="状态" prop="commentManagerUserStatus">
							<a-switch v-model="editModel.commentManagerUserStatus" @change="handleSwitch" />
							<span style="margin-left:10px">{{ editModel.commentManagerUserStatus ? '启用' : '禁用' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>


			</a-form-model>
		</a-modal>


		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>底部内容</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-input v-model.number="tipsModel.bottomContent" placeholder="内容" /></div>
		</a-modal>

	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../utils/oss";
	import cityData from '../../assets/json/citys_with_en.json'

	import {
		getCommentManagerUsersApi, //  执行标准列表
		getCommentManagerUserDetailApi, //  执行标准详情
		saveCommentManagerUserApi, //  执行标准新增/编辑
		deleteCommentManagerUserApi, //    执行标准删除
		StatusCommentManagerUserApi, //  执行标准 修改状态
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				cityList: cityData,
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'], // 颜色功能在这里
							['clean']

						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				commodityStatusList: [{
						label: "启用",
						value: true,
					},
					{
						label: "禁用",
						value: false,
					}
				],
				columns: [{
						title: '角色头像',
						dataIndex: 'avatar',
						key: 'avatar',
						scopedSlots: {
							customRender: "imageUrl"
						},
					},
					{
						title: '角色名称',
						dataIndex: 'nickname',
						key: 'nickname',
					},
					{
						title: '性别',
						dataIndex: 'sex',
						key: 'sex',
						scopedSlots:{
							customRender:"sexRender"
						}
					},
					{
						title: '角色简介',
						dataIndex: 'userDesc',
						key: 'userDesc',
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '发布状态',
						dataIndex: 'commentManagerUserStatus',
						key: 'commentManagerUserStatus',
						scopedSlots: {
							customRender: 'commentManagerUserStatusRender'
						},
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'STANDAR',
					onOk: () => {},
				},
				uploadLoading: false,
				editRules: {
					avatar: [{ required: true, message: '请上传角色头像', trigger: 'change' }],
					nickname: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
					sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
					userDesc: [{ required: true, message: '请输入角色简介', trigger: 'blur' }],
				},
				editModel: {
					flag: false,
					title: "",
					regulationName: '',
					regulationClause: '',
					avatar: "",
					sort: 0,
					regulationStatus: false,
					  areaCode: [],
					onOk: () => {},
				},
				formState: {
					"iconUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					// standardCode: "",
					// implementationStatus: undefined,
					lang: "CH",
					commentManagerUserStatus:undefined
					// tagId: undefined
				},
				tags: [],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('lawsRegulations_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1)
			this.getTagsLabel()
			this.initDragBrand1()
			this.initDragBrand2()
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('lawsRegulations_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			onChange(value, selectedOptions) {
				console.log(selectedOptions)
				this.editModel.province=selectedOptions[0].value
				this.editModel.city=selectedOptions[1].value
				// console.log(selectedOptions[0])
				// console.log(selectedOptions[1])
				// this.baseInfo.province = selectedOptions[0].text
				// this.baseInfo.provinceCode = selectedOptions[0].value
				// this.baseInfo.city = selectedOptions[1].text
				// this.baseInfo.cityCode = selectedOptions[2].value
			},
			handleSwitch(checked) {
				// v-model 已经自动更新 editModel.regulationStatus，这里只做额外逻辑
				console.log('新状态：', checked);
				// 如果不需要额外处理，这个方法甚至可以直接删掉，@change 都不用写
				//  this.editModel.regulationStatus = checked;
			},
			// 切换发布状态（带确认提示）
			handlePublishChange(checked, record) {
				// 动态生成提示文案
				let content = '';
				if (checked) {
					// 切换为 启用
					content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
				} else {
					// 切换为 禁用
					content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
				}
				this.$confirm({
					title: '操作确认',
					content: content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						// 确认后执行的操作
						// record.standardStatus = checked ? 1 : 0; // 接口需要数字，存回数字
						// 这里可以调用接口更新状态
						// TODO
						this.updateStatusApi(record.commentManagerUserId)
						console.log('发布状态已更新为：', record.regulationStatus);
					},
					onCancel: () => {
						// 取消时，保持开关原来的状态不变
						console.log('已取消操作');
					}
				});
			},
			updateStatusApi(commentManagerUserId) {
				StatusCommentManagerUserApi({
						commentManagerUserId: commentManagerUserId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								"修改成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			},

			// 保存排序（输入框回车/失焦触发）
			handleSaveSort(record) {
				// 排序号为空不提交
				if (record.sort === undefined || record.sort === null || record.sort === '') {
					return
				}
				// 调用你已有的排序接口
				updateRegulationSortApi({
					regulationId: record.regulationId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current) // 刷新列表，实现重排
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},

			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},

			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			initDragBrand1() {
				const el = this.$refs.dragContainerBrand
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.deptList.splice(oldIndex, 1)[0]
						this.deptList.splice(newIndex, 0, moveItem)
					},
				})
			},
			deleteDept(index) {
				this.deptList.splice(index, 1);
			},
			addDept() {
				if (!this.deptText) return;
				this.deptList.push(this.deptText);
				this.deptText = '';
			},
			initDragBrand2() {
				const el = this.$refs.dragContainerMain
				if (!el) return
				this.sortable = Sortable.create(el, {
					animation: 150, // 流畅动画
					handle: '.size_item', // 可拖拽元素
					draggable: '.size_item',
					forceFallback: false,
					ghostClass: 'sort-ghost',

					// 拖拽结束
					onEnd: (evt) => {
						const {
							oldIndex,
							newIndex
						} = evt
						// 数组顺序同步（核心！）
						const moveItem = this.mainList.splice(oldIndex, 1)[0]
						this.mainList.splice(newIndex, 0, moveItem)
					},
				})
			},
			deletemain(index) {
				this.mainList.splice(index, 1);
			},
			addMain() {
				if (!this.mainText) return;
				this.mainList.push({
					title: this.mainText
				});
				this.mainText = '';
			},
			getTagsLabel() {
				// getTagCategoriesApi({
				// 	tagTypeCategory: 'EXECUTION_STANDARD'
				// }).then((res) => {
				// 	if (res.resultStatus) {
				// 		this.tags = res.resultData[0].tags

				// 	} else {}

				// })


			},
			handleCategoryChange() {
				// 切换分类后，重置页码并刷新表格
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleSwitch(checked) {
				// v-model 已经自动更新 editModel.regulationStatus，这里只做额外逻辑
				console.log('新状态：', checked);
				// 如果不需要额外处理，这个方法甚至可以直接删掉，@change 都不用写
				//  this.editModel.regulationStatus = checked;
			},


			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						standardCode: "",
						lang: "CH",
						implementationStatus: undefined,
						tagId: undefined
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getCommentManagerUsersApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						nickname: this.filterData.nickname,
						commentManagerUserStatus: this.filterData.commentManagerUserStatus,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.editModel = {
					flag: true,
					title: "新增角色",
					"avatar": "",
					"nickname": "",
					"sex": undefined,
					"userDesc": "",
					areaCode: [],
					"commentManagerUserStatus": undefined,
					"province": "",
					"city": "",
					sort: this.pageInfo.total + 1,
					onOk: this.sureEdit,
				};
				this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate());
			},
			toEdit(data) {
				getCommentManagerUserDetailApi({
						commentManagerUserId: data.commentManagerUserId,
					})
					.then((res) => {
						if (res.resultStatus) {
							console.log(res.resultData, '看看返回的结果')
							const result = res.resultData;
							this.editModel = {
								"flag": true,
								"title": "编辑角色",
								commentManagerUserId:result.commentManagerUserId,
								"avatar": result.avatar,
								"nickname": result.nickname,
								"sex": result.sex,
								"userDesc": result.userDesc,
								"commentManagerUserStatus": result.commentManagerUserStatus,
								"province":result.province,
								"city": result.city,
								onOk: this.sureEdit,
							};
							this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate());
							// 1. 拼接级联需要的数组
							let areaArr = []
							if(this.editModel.province) areaArr.push(this.editModel.province)
							if(this.editModel.city) areaArr.push(this.editModel.city)
							this.editModel.areaCode=areaArr
							// this.editModel.areaCode= ["120000", "120100" ]
							// console.log(this.editModel.areaCode,'看看这个是哈')
						} else {
							console.log("res");
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			confirm() {

			},
			sureScript(data) {
				console.log(data, '看看这个值是什么')
			},
			// 话术编辑
			scriptEdit() {
				this.tipsModel = {
					flag: true,
					title: "执行标准页面话术编辑",
					bottomTitle: "",
					bottomContent: "",
					onOk: this.sureScript,
				};
			},
			sureEdit(data) {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return;
					saveCommentManagerUserApi({
						commentManagerUserId: this.editModel.commentManagerUserId || 0,
						"avatar": this.editModel.avatar, //法律法规名称
						"nickname": this.editModel.nickname, //标准文件
						"sex": this.editModel.sex, //排序
						"userDesc": this.editModel.userDesc, //排序
						"commentManagerUserStatus": this.editModel.commentManagerUserStatus, //排序
						"province": this.editModel.province, //排序
						"city": this.editModel.city, //排序
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.executionStandardId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
				});
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				deleteCommentManagerUserApi({
						commentManagerUserId: record.commentManagerUserId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传文件
			handleUploadThumbnail(e) {
				const file = e.target.files[0];
				if (!file) return;
				if (file.size > 3 * 1024 * 1024) {
					this.$message.warning('图片大小不能超过3M');
					e.target.value = '';
					return;
				}
				this.uploadLoading = true;
				ossUpload(file, '', 'pdf/').then((res) => {
					this.editModel.avatar = res.url;
					this.$refs.formRef && this.$refs.formRef.clearValidate && this.$refs.formRef.clearValidate('avatar');
				}).catch(err => {
					console.log("上传失败", err);
					this.$message.error('图片上传失败')
				}).finally(() => {
					this.uploadLoading = false;
					e.target.value = '';
				});
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
</style>

<style lang="less" scoped>
/deep/ .ant-form-item {
		margin-bottom: 8px;
	}
</style>
